                                                                                                                                                                                                                                                                       
     

 


 





// GLOBAL *****************************************


// redirects ***
var thisGlobalRedirectPath = window.location.pathname;
if (thisGlobalRedirectPath === "/cart" || thisGlobalRedirectPath === "/cart/") { window.location.href = "/?opencart=true"; }
if ((thisGlobalRedirectPath === "/products" || thisGlobalRedirectPath === "/products/") && window.location.search === '' && window.location.hash === '') { window.location.href = "/collections/all?sort_by=best-selling"; }
if ((thisGlobalRedirectPath === "/collections" || thisGlobalRedirectPath === "/collections/") && window.location.search === '' && window.location.hash === '') { window.location.href = "/collections/all?sort_by=best-selling"; }












// NAVIGATION MENU *****************************************
$(window).on("load", function() {




    // global ***
    let navMenuDone = true;




    // open + close clicks ***
    $("#NavHamburger").click(function() { navMenuOpenCloseHelper("open"); });  
    $("#NavigationMenuClose h2").click(function() { navMenuOpenCloseHelper("close"); });




    // scroll to ***
    $(".navmenuscroll").click(function() { 
	    if (navMenuDone) {
	        let scrollToSection = $(this).attr("data-scrollto");
		    $("html, body").animate({ scrollTop: $("#" + scrollToSection).offset().top - 160 }, 700, "easeInExpo"); 
		    navMenuOpenCloseHelper("close");   
	    }
    }); 




    // open + close helper *** 
    function navMenuOpenCloseHelper(type) {
        if (navMenuDone) { 
            navMenuDoneUtil(); 
            if (type === "open") {
                $("#NavigationMenu").addClass("active"); 
                setTimeout(function() { 
                    $("#NavigationMenuInner").addClass("active") 
                    setTimeout(function () {
                        $("#NavigationMenuInner h3").each(function(i, obj) {
                            setTimeout(function() { $(obj).addClass("active"); }, i * 100); 
                        });
                    }, 250);
                }, 100); 
            }
            else {
                $("#NavigationMenuInner").removeClass("active"); 
                setTimeout(function() { 
                    $("#NavigationMenu").removeClass("active") 
                    setTimeout(function() {
                        $("#NavigationMenuInner h3").removeClass("active");
                    }, 500);
                }, 250);
            }
        }   
    }




    // close on document press *** 
    $(document).click(function (e) {
        if ($("#NavigationMenu").hasClass("active")) { 
            if (!$(e.target).closest("#NavigationMenuInner").length && navMenuDone) {
                navMenuOpenCloseHelper("close");   
            }
        } 
    });




    // done util *** 
    function navMenuDoneUtil() {  
        navMenuDone = false;
	    setTimeout(function() { navMenuDone = true; }, 1000);  	  
    }  




});












// NAV SEARCH MODAL *****************************************    
$(window).on("load", function() {           




    // global ***
    let navSearchInput = $("#NavSearch input");    
    let navSearchResults = $("#NavSearchModalResultsInner"); 




    // display search results on input keyup + focus ***
    navSearchInput.on('keyup focus', function () {
        let navSearchQuery = navSearchInput.val().trim();
        if (navSearchQuery.length === 0) {
            $("#NavSearchModal").add("#NavSearchModalInner").removeClass("active");  
            return;
        }
        else {
            fetch("/search/suggest.json?q=" + encodeURIComponent(navSearchQuery) + "&resources[type]=product&resources[limit]=10")
            .then(r => r.json())
            .then(data => {
                navSearchResults.empty(); 
                let products = data.resources.results.products || [];
                if (products.length === 0) {
                    $("#NavSearchModalResultsHeader h2").addClass("noresults").html("No results found for <span>'" + navSearchQuery + "'</span>");
                    $("#NavSearchModalViewAllBtn").addClass("noresults");
                }
                else {
                    for (let i = 0; i < products.length; i++) {
                        let baseUrl = products[i].url.split("?")[0];
                        let variantUrl = baseUrl + "?variant=" + products[i].id;
                        navSearchResults.append(
                            "<a href='" + variantUrl + "'>" +          
                                "<div class='navsearchel'>" +
                                    "<img src='" + products[i].image + "'>" +
                                    "<div class='navsearchelcont'>" +
                                        "<p>" + products[i].vendor + "</p>" +
                                        "<h1>" + products[i].title + "</h1>" +
                                        "<h2>$" + products[i].price + "</h2>" +
                                    "</div>" +
                                "</div>" +
                            "</a>" 
                        );
                    }
                    $("#NavSearchModalViewAllBtn").removeClass("noresults").attr("href", "/search?q=" + navSearchQuery + "&sort_by=best-selling"); 
                    $("#NavSearchModalResultsHeader h2").removeClass("noresults").html("VIEWING <span>" + products.length + "</span> <strong>PRODUCTS</strong>");
                }
                $("#NavSearchModal").add("#NavSearchModalInner").addClass("active");
            })  
            .catch(console.error); 
        } 
    });

   


    // conduct search on enter press ***
    navSearchInput.on('keydown', function (e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            e.preventDefault(); 
            let val = $(this).val().trim();
            if (val.length > 0 && !$("#NavSearchModalViewAllBtn").hasClass("noresults")) {
                window.location.href = "/search?q=" + val + "&sort_by=best-selling";
            }
        }
    });




    // conduct search on nav btn press *** 
    $("#NavSearch img").click(function() {
        let val = $(this).parent().find("input").val().trim();
        if (val.length > 0 && !$("#NavSearchModalViewAllBtn").hasClass("noresults")) {
            window.location.href = "/search?q=" + val + "&sort_by=best-selling"; 
        }
    });




    // hide search modal on close press ***
    $("#NavSearchModalResultsHeader h4").click(function() {
        $("#NavSearchModal").add("#NavSearchModalInner").removeClass("active");   
    });




    // hide search modal on document press ***
    $(document).click(function (e) {
        if ($("#NavSearchModalInner").hasClass("active")) {
            if (!$(e.target).closest("#NavSearch").length && !$(e.target).closest("#NavSearchModalInner").length) {
                $("#NavSearchModal").add("#NavSearchModalInner").removeClass("active");   
            }
        } 
    });




});
 











// NAV PROD MENU *****************************************    
$(window).on("load", function() {                                       




    // temporary redirect to collection ***   
    $("#NavProdBtn").on("click", function() {
        window.location.href = "/collections/all";
    });




    /*
    // init ***
    let navProdMenu = $('#AllProductsMenu');
    let navProdMenuInner = $('#AllProductsMenuInner');
    let navProdMenuBtn = $('#NavProdBtn'); 
    let navProdMenuHoverTimer = null;




    // open on hover (desktop) *** 
    navProdMenuBtn.on('mouseenter', function () {
        if (window.matchMedia('(hover: hover)').matches) {
            clearNavProdHoverTimer();
            navProdMenuHoverTimer = setTimeout(function () {
                openNavProdMenu();
            }, 250);
        }
    });




    // clear hover timer on mouseleave (desktop) *** 
    navProdMenuBtn.on('mouseleave', function () {
        clearNavProdHoverTimer();
    });




    // open on click (desktop + mobile) *** 
    navProdMenuBtn.on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        clearNavProdHoverTimer();
        openNavProdMenu(); 
    }); 
  



    // hide on inner close btn press *** 
    $("#AllProductsMenuInnerNavClose").click(function() { 
        closeNavProdMenu(); 
    });




    // hide on document press ***
    $(document).click(function (e) {
        if (navProdMenu.hasClass("active")) {
            if (!$(e.target).closest("#AllProductsMenuInner").length && !$(e.target).closest("#NavProdBtn").length) {
                closeNavProdMenu(); 
            }
        } 
    });




    // inner nav *** 
    $(document).on("click", "#AllProductsMenuInnerNav h2", function() { 
        if (!$(this).hasClass("active")) {
            let thisInnerNavNum = $(this).attr("data-apmirid");
            $("#AllProductsMenuInnerNav h2.active").removeClass("active");
            $(this).addClass("active");
            $("#AllProductsMenuInnerResults .apmir-el.active .apmirei-el").removeClass("active");
            $("#AllProductsMenuInnerResults .apmir-el.active").removeClass("active");
            setTimeout(function() {
                $("#AllProductsMenuInnerResults .apmirel" + thisInnerNavNum).scrollTop(0);   
                $("#AllProductsMenuInnerResults .apmirel" + thisInnerNavNum).addClass("active"); 
                $("#AllProductsMenuInnerResults .apmirel" + thisInnerNavNum + " .apmirei-el").each(function(i, obj) {
                    setTimeout(function() { $(obj).addClass("active"); }, i * 100);
                });
            }, 250); 
        }
    });




    // open helper *** 
    function openNavProdMenu() {
        if (!navProdMenu.hasClass("active")) {
            navProdMenu.add(navProdMenuInner).add(navProdMenuBtn).addClass('active');
            $("#AllProductsMenuInnerNav h2.first").click();
        }
    }




    // close helper ***
    function closeNavProdMenu() {
        clearNavProdHoverTimer();  
        navProdMenu.add(navProdMenuInner).add(navProdMenuBtn).removeClass('active');
        $("#AllProductsMenuInnerNav h2.active").removeClass("active");
        $("#AllProductsMenuInnerResults .apmir-el.active .apmirei-el").removeClass("active");
        $("#AllProductsMenuInnerResults .apmir-el.active").removeClass("active");
    }




    // clear hover timer helper ***
    function clearNavProdHoverTimer() {
        if (navProdMenuHoverTimer) {
            clearTimeout(navProdMenuHoverTimer);
            navProdMenuHoverTimer = null;
        }
    }
    */




});










  

// CART FUNCTIONALITY *****************************************
$(window).on("load", function () {       




    // init ***
    var doneUtil = [{ done: true }, { done: true }, { done: true }, { done: true }];
    var addToCart = false;
    var firstAddToCart = true;
    var totalCartItems = 0;
    var totalPrice = 0;
    var freeShippingNum = 500;
    var setTotalCartItemsAgain = true;
    var CART_FETCH_MAX_RETRIES = 8;




    // set total cart items ***
    setTotalCartItems();




    // open cart press ***
    $("#NavCartButton").click(function () {
        if (doneUtil[0].done) {
            doneUtilFunc(0, 1000);
            if (setTotalCartItemsAgain) {
                setTotalCartItemsAgain = false;
                setTotalCartItems();
            }
            let openCartDelay = 250; 
            if (!addToCart && totalCartItems !== 0) {
                fetchCartData({
                    delay: 50,
                    openAfterLoad: false
                });
                openCartDelay = 400;
            }  
            openCartSuccess(openCartDelay);
        }
    });




    // open cart success ***
    function openCartSuccess(delayTimer) {
        setTimeout(function () {
            $("#CartSection").css({ "display": "block" }); 
            setTimeout(function () {
                addToCart = false;
                if (!firstAddToCart) { firstAddToCart = true; }
                ddsCartIsEmpty(totalCartItems === 0);
                $("#CartSection").addClass("active");
                $("#CartSection #Cart").addClass("active");
            }, 50);
        }, delayTimer);
    }




    // close cart ***
    $("#CartClose").click(function () {
        if (doneUtil[0].done) {
            doneUtilFunc(0, 1000);
            $("#CartSection #Cart").removeClass("active");
            setTimeout(function () { 
                $("#CartSection").removeClass("active"); 
                setTimeout(function () {
                    $("#CartSection").css({ "display": "none" });
                }, 550); 
            }, 300);
        }
    });




    // add to cart buttons ***
    $(document).on("click", ".dds-prodcheckoutadd.pcinstock, #FeaturedAdd", function () {
        if (doneUtil[1].done && firstAddToCart) {
            doneUtilFunc(1, 1000);

            // loading animation 
            let $btn = $(this);
            if ($btn.find(".loadingoverlay").length) { return; }
            $btn.append("<div class='loadingoverlay'><img src='//forefrontdent.com/cdn/shop/t/2/assets/loading.gif?v=80914555249726518261789087049'></div>");
            let $btnOver = $btn.find(".loadingoverlay");
            setTimeout(function() {
                $btnOver.addClass("active");
                setTimeout(function () {
                    $btnOver.removeClass("active");
                    setTimeout(function() {
                        $btnOver.remove();
                    }, 350);
                }, 2000); 
            }, 50);
    
            // set cart item again
            if (setTotalCartItemsAgain) {
                setTotalCartItemsAgain = false;
                setTotalCartItems();
            }

            // add to cart flag 
            addToCart = true;

            // prepare cart item object 
            let qty;
            let variant;
            let cartItems = {};
            let buyNow = false;
            if ($(this).hasClass("prodpageadd")) {
                qty = Number($("#FeaturedQuantity span.qty").text());
                variant = $("#FeaturedContentInner").attr("data-activevariantid");
            } 
            else {
                qty = Number($(this).parent().find(".dds-prodcheckoutqty span.qty").text());
                variant = $(this).attr("data-variantid");
            }
            cartItems.quantity = qty;
            cartItems.id = variant;
            let subscription = $("#SubscriptionDropDown");
            if (subscription.hasClass("active")) {
                let planId = subscription.find("h5.active").attr("data-plan-id");
                if (planId) {
                    cartItems.selling_plan = planId;
                }
            }

            // buy now case 
            if ($(this).hasClass("bn")) {
                buyNow = true;
            }

            // add to cart handler
            $.ajax({
                type: "POST",
                url: "/cart/add.js",
                data: { items: [cartItems] },
                dataType: "json",
                success: function () {
                    fetchCartData({
                        delay: 250,
                        addedQty: qty,
                        buyNow: buyNow,
                        openAfterLoad: true
                    });
                },
                error: function () { 
                    addToCart = false;
                    firstAddToCart = true;
                    setTotalCartItems();
                    fetchCartData({ delay: 0, openAfterLoad: false });
                }
            });

        }
    });




    // fetch cart data *** 
    function fetchCartData(options) {

        // init 
        options = options || {};
        let timeoutDelay = options.delay || 0;
        let nQty = Number(options.addedQty || 0);
        let bn = options.buyNow === true;
        let retries = Number(options.retries || 0);
        let openAfterLoad = options.openAfterLoad === true;

        // operations 
        setTimeout(function () {
            if (bn) {
                setTimeout(function () {
                    window.location.href = "/cart/checkout";
                }, 500);
                return;
            }
            fetch(window.Shopify.routes.root + "cart.js")
                .then(function (response) {
                    return response.json();
                })
                .then(function (data) {
                    if (addToCart && firstAddToCart && nQty > 0) {
                        firstAddToCart = false;
                        totalCartItems += nQty;
                    }
                    if ((data.item_count === 0 || data.item_count < totalCartItems) && retries < CART_FETCH_MAX_RETRIES) {
                        fetchCartData({
                            delay: 250,
                            addedQty: 0,
                            buyNow: false,
                            retries: retries + 1,
                            openAfterLoad: openAfterLoad
                        });
                        return;
                    }
                    useCartData(data);
                    if (openAfterLoad && addToCart) {
                        $("#NavCartButton").click();
                    }
                })
                .catch(function () {  
                    setTotalCartItems();
                });
        }, timeoutDelay);

    }




    // display fetched cart data ***
    function useCartData(data) {

        // clear cart 
        $("#Cart #CartItems").html("");

        // set price & cart items  
        totalPrice = 0;
        totalCartItems = data.item_count || 0;

        // render cart items
        for (let i = 0; i < data.items.length; i++) {
            let item = data.items[i];
            let realPrice = item.price / 100;
            let priceDisplay = "$" + realPrice.toFixed(2);
            if (item.quantity > 1) {
                priceDisplay =
                    "$" + (realPrice * item.quantity).toFixed(2) +
                    " <span class='unit-price'>($" + realPrice.toFixed(2) + " /ea)</span>";
            }
            $("#Cart #CartItems").append(
                "<div class='cartitem " + item.id + "'>" +
                    "<img class='citemcol img' src='" + item.image + "'>" +
                    "<div class='citemcol header'>" +
                        "<h2>" + item.title + "</h2>" +
                        "<p>" + priceDisplay + "</p>" +
                    "</div>" +
                    "<div class='citemcol adjust'>" +
                        "<h5 data-adjustid='" + item.id + "' data-adjustprice='" + realPrice + "' data-adjustkey='" + item.key + "'>" +
                            " <span class='minus mp'>-</span> <span class='qty'>" + item.quantity + "</span> <span class='plus mp'>+</span>" +
                        " </h5>" +
                        "<a class='removecartitem' data-removalid='" + item.id + "' data-removalprice='" + realPrice + "' data-removalkey='" + item.key + "'>REMOVE</a>" +
                    "</div>" +
                    "<div class='citemclearfloat'></div>" +
                "</div>"
            );
            totalPrice += realPrice * item.quantity;
        }

        // handle other operations   
        fetchRecoItems();
        setShippingSliderPos();
        $("#CartFooter a span.total").text("$" + totalPrice.toFixed(2));
        $("#NavCartButtonNum").text(totalCartItems);
        ddsCartIsEmpty(totalCartItems === 0);

    } 




    // adjust cart qty ***
    $(document).on("click", ".citemcol.adjust h5 span.mp", function () {
        if (doneUtil[2].done) {
            doneUtilFunc(2, 300);
            let nThis = $(this);
            let type = nThis.attr("class");
            let $row = nThis.parent();
            let thisQty = Number($row.find(".qty").text());
            let thisKey = $row.attr("data-adjustkey");
            if (type === "minus mp" && thisQty > 1) {
                thisQty--;
            } 
            else if (type === "plus mp") {
                thisQty++;
            } 
            else {
                return;
            } 
            $.ajax({
                type: "POST",
                url: "/cart/change.js",
                data: {
                    id: thisKey,
                    quantity: thisQty
                },
                dataType: "json",
                success: function (data) {
                    nThis.parent().find(".qty").text(thisQty); 
                    useCartData(data);
                },
                error: function () {   
                    fetchCartData({ delay: 0, openAfterLoad: false });
                }
            });
        }
    }); 




    // remove cart item ***
    $(document).on("click", ".citemcol.adjust .removecartitem", function () {
        if (doneUtil[3].done) {
            doneUtilFunc(3, 1000);
            let nThis = $(this);
            let thisRemovalKey = nThis.attr("data-removalkey"); 
            $.ajax({
                type: "POST",
                url: "/cart/change.js",
                data: {
                    id: thisRemovalKey,
                    quantity: 0
                },
                dataType: "json",
                success: function (data) {
                    useCartData(data);   
                },
                error: function () {
                    fetchCartData({ delay: 0, openAfterLoad: false });
                }
            });
        }
    });   




    // add reco item ***
    $(document).on("click", ".citemcol.recoadd h5", function () {
        addToCart = true;
        let recoVariantId = $(this).attr("data-recoaddid");
        $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: { items: [{ quantity: 1, id: recoVariantId }] },
            dataType: "json",
            success: function () {
                fetchCartData({
                    delay: 250,
                    addedQty: 1,
                    buyNow: false,
                    openAfterLoad: false
                });
            },
            error: function () {
                fetchCartData({ delay: 0, openAfterLoad: false });
            }
        });
    });




    // fetch reco items ***
    async function fetchRecoItems() {
        try {

            // init 
            const response = await fetch(window.Shopify.routes.root + "cart.js");
            const data = await response.json();
            let cartItems = data.items || [];
            let seen = [];
            let recoResults = [];

            // get recos 
            for (let i = 0; i < cartItems.length; i++) {
                seen.push(cartItems[i].product_id);
                let url = new URL(window.Shopify.routes.root + "recommendations/products.json", location.origin);
                url.searchParams.set("product_id", cartItems[i].product_id);
                url.searchParams.set("intent", "related");
                url.searchParams.set("limit", "6");
                const recoResponse = await fetch(url);
                const recoData = await recoResponse.json();
                if (recoData.products && recoData.products.length) {
                    for (let j = 0; j < recoData.products.length; j++) {
                        let recoProduct = recoData.products[j];
                        if (!recoProduct) { continue; }
                        if (!seen.includes(recoProduct.id)) {
                            seen.push(recoProduct.id);
                            recoResults.push(recoProduct);
                            break; 
                        }
                    }
                }
            }

            // render recos 
            $("#CartRecoItems").html("");
            for (let k = 0; k < recoResults.length; k++) {
                let reco = recoResults[k];
                let firstVariant = reco.variants && reco.variants.length ? reco.variants[0] : null;
                if (!firstVariant) { continue; } 
                $("#CartRecoItems").append(
                    "<div class='cartitem " + reco.id + "'>" +
                        "<img class='citemcol img' src='" + reco.featured_image + "'>" +
                        "<div class='citemcol header'>" +
                            "<a href='/products/" + reco.handle + "?variant=" + firstVariant.id + "'>" +
                                "<h2>" + reco.title + (firstVariant.title === "Default Title" ? "" : " - " + firstVariant.title) + "</h2>" +
                                "<p> $" + (reco.price / 100).toFixed(2) + "</p>" +
                            "</a>" +
                        "</div>" +
                        "<div class='citemcol recoadd'>" +
                            "<h5 data-recoaddid='" + firstVariant.id + "'>ADD</h5>" +
                        "</div>" +
                        "<div class='citemclearfloat'></div>" +
                    "</div>"
                );
            }

        } 
        catch (e) { 
            $("#CartRecoItems").html("");
        }
    }




    // set shipping slider position ***
    function setShippingSliderPos() { 
        if (totalPrice < freeShippingNum) {
            let pct = Math.max(0, Math.min((totalPrice / freeShippingNum) * 100, 100));
            let remainingAmount = Math.round((freeShippingNum - totalPrice) * 100) / 100;
            $("#CartFreeShippingSliderPos").css({ "width": pct + "%" });
            $("#CartFreeShipping h3").html("You are <span>$" + remainingAmount.toFixed(2) + "</span> away from <span>free shipping!</span>");
        } 
        else {
            $("#CartFreeShippingSliderPos").css({ "width": "100%" });
            $("#CartFreeShipping h3").html("Congrats! You've unlocked <span>free shipping!</span>");
        }
    }




    // set total cart items ***
    function setTotalCartItems() {
        fetch(window.Shopify.routes.root + "cart.js")
            .then(function (response) {
                return response.json();
            })
            .then(function (data) {
                totalCartItems = data.item_count || 0;
                $("#NavCartButtonNum").text(totalCartItems);
            })
            .catch(function () {
                totalCartItems = 0;
                $("#NavCartButtonNum").text(totalCartItems);
            });
    }




    // cart empty ***
    function ddsCartIsEmpty(type) {
        if (type === true) {
            $("#CartHasItems").css({ "display": "none" });
            $("#CartEmpty").css({ "display": "block" });
        } 
        else {
            $("#CartHasItems").css({ "display": "block" });
            $("#CartEmpty").css({ "display": "none" });
        }
    }




    // close on document press ***
    $(document).click(function (e) {
        if ($("#CartSection").hasClass("active")) {
            if (!$(e.target).closest("#Cart").length && doneUtil[0].done) {
                $("#CartClose").click();
            }
        }
    });




    // done util ***
    function doneUtilFunc(pos, delay) {
        doneUtil[pos].done = false;
        setTimeout(function () {
            doneUtil[pos].done = true;
        }, delay);
    }




});












// FEATURED PRODUCTS ***************************************** 
$(window).on("load", function() {             




    // change item quantity ***
    $(document).on("click", ".dds-prodcheckout .pcqtyadjust", function() {  

    	let currentQty = Number($(this).parent().attr("data-currentqty"));
        let qtySpan = $(this).parent().find("span.qty"); 

        if ($(this).hasClass("plus")) {
            currentQty++;
            qtySpan.text(currentQty);  
        }

        if ($(this).hasClass("minus") && currentQty > 1) { 
            currentQty--;
            qtySpan.text(currentQty);   
        }

        $(this).parent().attr("data-currentqty",currentQty )

    }); 




    // varaint dd open *** 
    $(document).on("click", ".dds-prodvariantdd-active", function() {  
        let menu = $(this).parent().find(".dds-prodvariantdd-menu");
        let thisParentProduct = $(this).parent().parent();
        $(".dds-prodvariantdd-menu.active").not(menu).removeClass("active");
        $(".dds-product.variantddopen").not(thisParentProduct).removeClass("variantddopen");   
        if (menu.hasClass("active")) {
            menu.removeClass("active");     
            thisParentProduct.removeClass("variantddopen");
        }
        else {
            menu.addClass("active");
            thisParentProduct.addClass("variantddopen"); 
        }
    });




    // variant dd option press *** 
    $(document).on("click", ".dds-prodvariant-option", function() {  
        
        // init this dd variant el + parent product 
        let thisEl = $(this);
        let parentProduct = thisEl.parent().parent().parent();

        // update parent link, img, variant title 
        let prodLink = parentProduct.find(".dds-prodanchor");
        let prodImg = parentProduct.find(".dds-prodimg");
        let prodVariantTitle = parentProduct.find(".dds-active-variant-title");
        prodLink.attr("href", thisEl.attr("data-varianturl")); 
        prodImg.attr("src", thisEl.attr("data-img")); 
        prodVariantTitle.html(thisEl.attr("data-varianttitle")); 
        
        // update parent add to cart btn + handle oos case 
        let variantInStock = thisEl.attr("data-available"); 
        let prodAddToCartBtn = parentProduct.find(".dds-prodcheckoutadd");
        let prodCheckoutDiv = parentProduct.find(".dds-prodcheckout"); 
        prodAddToCartBtn.remove();  
        if (variantInStock === "false") {  
            prodCheckoutDiv.append("<h2 class='dds-prodcheckoutadd pcoutofstock'>Out of Stock</h2>"); 
        }  
        else { 
            prodCheckoutDiv.append("<h2 class='dds-prodcheckoutadd pcinstock' data-variantid='" + thisEl.attr("data-variantid") + "'>Add To Cart</h2>");
        } 

        // update parent price + handle discount case  
        let variantDiscount = thisEl.attr("data-discount");       
        let prodPrice = parentProduct.find(".dds-prodprice"); 
        if (variantDiscount === "false") {
            prodPrice.html(thisEl.attr("data-price"));
        }
        else {
            prodPrice.html(
                "<span class='dds-prodoldprice'>" + thisEl.attr("data-compareat") + "</span>" +
                "<span class='dds-prodsaleprice'>" + thisEl.attr("data-price") + "</span>" +
                "<span class='dds-proddiscount'>" + variantDiscount + "</span>" 
            );
        }

        // update dd title
        let ddTitle = thisEl.parent().parent().find(".dds-prodvariantdd-active");
        ddTitle.find(".title").html(thisEl.attr("data-varianttitle"));    

        // update active dd value 
        thisEl.parent().find(".dds-prodvariant-option.active").removeClass("active");
        thisEl.addClass("active"); 

        // close dd 
        thisEl.parent().removeClass("active");

    });




    // variant dd close on document press *** 
    $(document).click(function (e) {
        if ($(".dds-prodvariantdd-menu").hasClass("active")) {
            if (!$(e.target).closest(".dds-prodvariantdd").length) { 
                $(".dds-prodvariantdd-menu.active").removeClass("active");
                $(".dds-product.variantddopen").removeClass("variantddopen");   
            }
        } 
    });




});












// REVIEW SECTION *****************************************
$(window).on("load", function() {


    // init ***
    let ptsGuard = false;
    let ptsIndex = 0;
    const ptsTotalSlides = $("#FooterReviewSection .prod-testimonial").length;


    // center slide ***
    function centerSlide($slide) {
        const h = $slide.outerHeight();
        $slide.css("top", "calc(50% - " + (h / 2) + "px)");
    }


    // animate logos ***
    function animatePTSLogos() {
        $("#FooterReviewSection .pts-logo").each(function() {
            const current = Number($(this).data("rotation")) || 0;
            const amount = Math.random() > 0.5 ? 50 : 25;
            const direction = Math.random() > 0.5 ? 1 : -1;
            const next = current + (amount * direction);
            $(this).data("rotation", next);
            $(this).css("transform", "rotate(" + next + "deg)");
        });
    }


    // nav ***
    function ptsNav(direction) {
        if (ptsGuard) return;
        ptsGuard = true;
        setTimeout(() => { ptsGuard = false; }, 1000);
        const $slides = $("#FooterReviewSection .prod-testimonial");
        const $current = $slides.filter(".active");
        ptsIndex = direction === "next"
            ? (ptsIndex === ptsTotalSlides - 1 ? 0 : ptsIndex + 1)
            : (ptsIndex === 0 ? ptsTotalSlides - 1 : ptsIndex - 1);
        const $next = $slides.eq(ptsIndex);
        centerSlide($next);
        animatePTSLogos();
        $current.removeClass("active");
        setTimeout(() => { $next.addClass("active"); }, 500);
    }


    // triggers ***
    $("#PTS-prev").on("click", function() { ptsNav("prev"); });
    $("#PTS-next").on("click", function() { ptsNav("next"); });


    // center first slide ***
    centerSlide($("#FooterReviewSection .prod-testimonial.active"));


});












// FOOTER MAP *****************************************
$(window).on("load", function() {


    // init map ***
    var map = new google.maps.Map(document.getElementById("MapSection"), {
        zoom: 11,
        scrollwheel: false,
        center: { lat: 34.1645217, lng: -118.5319203 },
        disableDefaultUI: true,
        styles: [{"elementType":"geometry","stylers":[{"color":"#FFFFFF"}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#D0D0D0"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#FFFFFF"}]},{"featureType":"administrative","elementType":"geometry","stylers":[{"color":"#F4F4F4"}]},{"featureType":"poi","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#F7F7F7"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#E4E4E4"}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#EEEEEE"}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#FAFAFA"}]},{"featureType":"road","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"transit","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#F0F0F0"}]}]
    });


    // init marker ***
    var marker = new google.maps.Marker({
        position: new google.maps.LatLng(34.1645217, -118.5319203),
        map: map,
        icon: {
            url: "//forefrontdent.com/cdn/shop/t/2/assets/marker.png?v=41028024285718778871789278354",
            scaledSize: new google.maps.Size(50, 65)
        }
    });


});












// ANIMATION ELEMENT *****************************************
$(window).on("load", function() {
    $(window).on("scroll", function() {
        $(".animation-element, .parallax-element").each(function() {
            

            // init ***
            var elem = $(this); 
            var windowTop = $(window).scrollTop(); 
            var windowBottom = (windowTop + $(window).height()); 
            var elementTop = elem.offset().top; 
            var elementBottom = (elementTop + elem.height());  
            

            // run in view animations ***
            if (( elementBottom >= windowTop ) && ( elementTop <= windowBottom )) { 
                // ae
                if (elem.hasClass("animation-element")) {
                    // init 
                    var num = elem.attr("data-num");    
                    // general
                    $(".animation" + num).addClass("in-view");  
                    // stat 
                    if (elem.hasClass("stat") && !(elem.hasClass("statdone"))) {   
                        elem.addClass("statdone");  
                        var statSec = $("#FMSContent");  
                        statSec.find(".stat").each(function(i) {
                            var counter = $(this);
                            $({ countNum: counter.text() }).animate({ countNum: counter.attr("data-count") }, { 
                                duration: 2500,
                                easing: "linear", 
                                step: function() { counter.text(Math.floor(this.countNum)); },
                                complete: function() { counter.text(this.countNum); }
                            });  
                        });
                    }       
                } 
                // parallax       
                if (elem.hasClass("parallax-element")) { 
                    // init 
                    var scrollDistance = windowBottom - elementTop; 
                    var percent = scrollDistance / ($(window).height() + elem.height());
                    var distance = percent * elem.attr("data-distance");  
                    // cases 
                    if ((elem.hasClass("down"))) { elem.css({"transform": "translate(0px," + distance + "px)" }); }  
                    if ((elem.hasClass("up"))) { elem.css({"transform": "translate(0px," + (-distance) + "px)" }); }   
                }
            }

         
        });
    }).scroll();
});









 

